var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('titles',{attrs:{"title":"总税收与缴费率对比罗盘"}}),_c('div',{staticClass:"ms"},[_vm._v("本市年度纳税耗时总计为55个小时,较第一名上海差10个小时,其中耗时差别最大两部分为:账簿分子及更新汇集账簿")]),_c('div',{staticClass:"duibix"},[_c('duibi2'),_c('shuilv')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }